
  export const BREAKPOINTS = {
    tablet: 1280,
    mobile: 600,
  };
  
  export const PHONE_MASK = '(###) ###-####';
  
  export const CURRENCY_OPTIONS = {
    mdCurrency: {
      locale: 'en-US',
      currency: 'USD',
      precision: 0,
    },
    mdPercent: {
      locale: 'en-US',
      currency: {
        suffix: '%',
      },
      precision: 0,
    },
  };
  
  export const OFFER_STATUSES = {
    offered: 1,
    viewed: 2,
    saved: 3,
    accepted: 4,
    declined: 5,
    converted: 6,
    expired: 7,
    funded: 8,
  };
  
  export const SLIDER_RESPONSIVE_OPTIONS = {
    savedOffers: {
      0: {
        disable: true,
        gutter: 0,
      },
      600: {
        disable: false,
        gutter: 0,
        items: 2,
      },
      900: {
        disable: false,
        gutter: 0,
        items: 3,
      },
    },
    partners: {
      0: {
        items: 2,
      },
      400: {
        items: 3,
      },
      600: {
        items: 4,
      },
    },
  };
  
  export const COUNT_UP_OPTIONS = {
    useEasing: true,
    useGrouping: true,
    separator: ',',
    decimal: '.',
    prefix: '$',
    suffix: '',
  };
  
  export const ANSWERS = {
    occupancyTypes: {
      primaryHome: 'Primary Residence',
      secondHome: 'Second Home',
      rentalProperty: 'Rental Property',
    },
    propertyTypes: {
      singleFamily: 'Single Family',
      townhome: 'Townhome',
      condo: 'Condo',
      multiFamily: 'Multi-Family',
      manufactured: 'Manufactured',
    },
    prefferedTerms: {
      ten: '10 Year Fixed',
      fifteen: '15 Year Fixed',
      twenty: '20 Year Fixed',
      twentyFive: '25 Year Fixed',
      thirty: '30 Year Fixed',
    },
    timelineTypes: {
      asap: 'As soon as possible',
      onoTwoMonths: '30-60 Days',
      moreTwoMonths: 'More than 60 days',
    },
    RefinaceReason: {
      cachOut: 'Cash Out',
      term: 'Change of Rate Term',
    },
  };
  